import React, {useEffect} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {sharingPageReady} from "../../../actions/profileActions";
import UsersList from "./screens/users-list";
import './index.css';
import AccessDeniedPage from '../../components/access-denied-page';

function Dashboard () {

	const profile = useSelector(state => state.profileReducer.getProfile);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(sharingPageReady(true));
    }, [dispatch]);

    if (profile.role === "ADMINISTRATOR") {
	    return (
		    <div className="dashboard">
			    <UsersList/>
		    </div>
	    )
    } else {
        return (
	        <AccessDeniedPage/>
        )
    }

}

export default Dashboard;
